import React from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

import SelectComponent from "@common/components/shared/forms/SelectComponent";
import CustomerForm from "@common/components/shared/CustomerForm";
import InteractionOptionsAction from "@common/redux/actions/InteractionOptionsAction";
import CustomerInteractionAction from "@common/redux/actions/CustomerInteractionAction";
import CustomerOutcomeForm from "./CustomerOutcomeForm";
import useCustomerInteractionForm from "../../hooks/useCustomerInteractionForm";
import DateAndTimeGroup from "../forms/DateAndTimeGroup";
import { getCurrentDateTime } from "../../helpers/datetime";
import AlertsAndSessions from "../AlertsAndSessions";
import { mapToSelect } from "@common/components/helpers/forms";

const InteractionForm = () => {
  const {
    loadingOptions,
    customerInteractionOptions: { reasons, actions },
  } = useSelector((state) => InteractionOptionsAction.getStatePath(state));
  const methods = useFormContext();
  const {
    control,
    formState: { errors },
  } = methods;
  const {
    onSelect,
    handleNewCustomer,
    handleEditCustomer,
    handleRemoveCustomer,
    handleExistingCustomer,
  } = useCustomerInteractionForm();

  return (
    <>
      <DateAndTimeGroup
        dateName="interactionDate"
        timeName="interactionTime"
        control={control}
        dateFormat="YYYY-MM-DD"
        errorsDate={errors.interactionDate}
        errorsTime={errors.interactionTime}
        maxDate={getCurrentDateTime()}
      />
      <AlertsAndSessions />
      <CustomerForm
        onSelect={onSelect}
        handleNewCustomer={handleNewCustomer}
        handleExists={handleExistingCustomer}
        handleEditCustomer={handleEditCustomer}
        handleRemoveCustomer={handleRemoveCustomer}
        handleResetCustomer={CustomerInteractionAction.reset}
        unknownNameLabel="Customer unwilling to give name"
      />
      <SelectComponent
        name="reason"
        label="Reason for interaction"
        placeholder="Select ..."
        control={control}
        error={errors.reason}
        options={mapToSelect(reasons)}
        labelStyle="w-40"
        loading={loadingOptions}
      />
      <SelectComponent
        name="actionTaken"
        label="Action taken"
        placeholder="Select ..."
        control={control}
        error={errors.actionTaken}
        options={mapToSelect(actions)}
        labelStyle="w-40"
        loading={loadingOptions}
      />
      <CustomerOutcomeForm />
    </>
  );
};

export default InteractionForm;
